import { Component, ElementRef, EventEmitter, HostListener, Input, Output, Renderer2, ViewChild, inject } from '@angular/core';
import { NotificationComponent } from './notification/notification.component';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { UserDropDownComponent } from './user-drop-down/user-drop-down.component';
import {
  ScreenHelper,
  StorageConstants,
  TabGetService
} from '@techextensor/tab-core-utility';
import { Constants, MenuCategoryId, UserRole } from '../../core/const/constants';
import { HelperFunctionService } from '../../core/services/helper-function.service';
import { MenuComponent, MenuModule } from '@syncfusion/ej2-angular-navigations';
import { MenuItemModel } from '@syncfusion/ej2-navigations';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AppSwtichComponent } from './tab-app-switch/tab-app-switch.component';
import { GlobalSearchComponent } from './global-search/global-search.component';
import { PermissionService } from '../../core/services/permission.service';
import { OrgAppInfoHelperService } from '../../core/services/org-app-info-helper.service';
import { Subject, forkJoin, of, takeUntil } from 'rxjs';
import { AuthService } from '../../core/services/auth.service';
import { environment } from '../../../environments/environment';
import { TabSdk } from '@techextensor/tab-sdk';
import { TranslationToken } from '../../core/const/translation.token';
import { BroadcastChannelService } from '../../core/services/cross-tab-authentication.service';
import { DevToolBridgeService } from '../../core/services/dev-tool/dev-tool-bridge.service';

@Component({
  selector: 'app-header',
  imports: [
    NotificationComponent,
    UserDropDownComponent,
    NgIf,
    NgClass,
    MenuModule,
    AppSwtichComponent,
    GlobalSearchComponent,
    NgFor,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  environment: any;
  environmentList: any[] = [];
  isBuildAndDevelopeModeUsercanAccess: boolean = false;
  isShowUserEnvironment: boolean = false;
  panelStatus: boolean = true;
  isNotificationListVisible: boolean = false;
  isUserDropDownVisible: boolean = false;
  notificationCount: number = 0;
  showLoader: boolean = false;
  private _authService: AuthService = inject(AuthService);
  private readonly _helperFunctionService: HelperFunctionService = inject(HelperFunctionService);
  public tabGetService: TabGetService = inject(TabGetService);
  private readonly permissionService: PermissionService = inject(PermissionService);
  private readonly router: Router = inject(Router);
  public readonly route: ActivatedRoute = inject(ActivatedRoute);
  public readonly _tabOrgAppInfoHelperService: OrgAppInfoHelperService = inject(OrgAppInfoHelperService);
  public readonly _broadcastChannelService: BroadcastChannelService = inject(BroadcastChannelService);
  private readonly _tabScreenHelper: ScreenHelper = inject(ScreenHelper);

  public appNavigation: any;
  @Input() isAdminRoute: boolean = false;
  @Output() panelOpenClose = new EventEmitter<boolean>();
  @ViewChild('popup') popup: ElementRef | undefined;
  @ViewChild('menuObj') menuObj!: MenuComponent;
  @ViewChild('globalSearch') globalSearch!: GlobalSearchComponent;
  private readonly devToolBridge = inject(DevToolBridgeService);
  menuItems: any[] = [];
  isHorizontalLayout: boolean = false;
  orgInfo: any;
  orgLogo: any;
  enablescroll!: boolean;
  menuCssClass: string = '';
  fullScreen: boolean = false;
  selectedLanguage: string;
  languageList: any = [];
  activeScreen: any;
  environmentName = TabSdk.store.environmentName;
  private destroy$ = new Subject<void>();

  // Listen for window resize events
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenWidth(event);
    if (this.isHorizontalLayout && this.menuObj) {
      this.menuObj.refresh();
    }
  }

  // @HostListener('window:keydown.F12', ['$event'])
  // handleF12Toggle(event: any) {
  //   this.toggleDebugTools();
  // }

  constructor(private renderer: Renderer2) {
    this.selectedLanguage = TabSdk.translator.getCurrentLanguage();
    this.orgInfo = TabSdk.store.orgLocaleSettings;
    this.getMenuLogo();
    this.isHorizontalLayout = this.orgInfo != null ? Boolean(this.orgInfo?.ShowHorizontalLayout) : false;

    const appInfo = TabSdk.store.getAppInfo() ?? {};
    const tenantId = TabSdk.store.tenantId;
    const appId = TabSdk.store.appId ?? '';
    this.isBuildAndDevelopeModeUsercanAccess = (
      appInfo?.TenantId?.Id?.toLowerCase() === tenantId?.toLowerCase() && (
        this.permissionService.doesUserIsAppAdmin() ||
        this.permissionService.doesUserIsTabAdministrator()
      )
    );
    // for show user wise Application environment
    this.isShowUserEnvironment = (appId.toLowerCase() != environment.commonConfig.applicationId.toLowerCase())
    this.appNavigation = TabSdk.store.getSession(StorageConstants.appNavigationMapping);
    // if (window.innerWidth <= 1600) {
    //   this.enablescroll = true;
    //   this.menuCssClass = this.enablescroll ? 'e-custom-scroll' : '';
    // }
  }

  ngOnInit(): void {
    this.devToolBridge.reconnectIfPopupOpen();
    // TODO: [BE-REWRITE-PENDING] Re-enable after BE rewrite - Language API. Flow kept, do not remove.
    // this.getLanguageList();

    // Notifications connect here (not in the route resolver) — the bell badge
    // is the only consumer, and we don't want a slow / unreachable WS to block
    // the route render. Fire-and-forget: badge populates via the stream once
    // the WS opens (or stays at 0 if BE is unreachable).
    const userId = TabSdk.store.userId;
    const appId = TabSdk.store.appId;
    const tenantId = TabSdk.store.tenantId;
    const environmentId = TabSdk.store.environmentId;
    if (userId && appId && tenantId && environmentId) {
      TabSdk.notification.connect({ userId, appId, tenantId, environmentId });
    }

    // Subscribe to unread count for the bell badge — service emits whenever
    // the WebSocket reports a count change (initial fetch on connect, after
    // any read/clear action, and on broadcasts from other sessions).
    TabSdk.notification.unreadCount$
      .pipe(takeUntil(this.destroy$))
      .subscribe(count => {
        this.notificationCount = count;
      });

    if (this.isHorizontalLayout) {
      this.loadHorizontalMenuitems();
      this.router.events
        .pipe(takeUntil(this.destroy$))
        .subscribe((event: any) => {
          if (event instanceof NavigationEnd) {
            this.updateActiveScreen();
          }
        });
    }
    if (this.isShowUserEnvironment) {
      this.getAppwiseUserEnvironment();
    }
  }

  /**
   * Gets the list of application-wise user environments and sets the default environment.
   * This method is called only once, during the component's initialization.
   * It makes an API call to fetch the list of application-wise user environments and stores the
   * default environment in session storage.
   */
  async getAppwiseUserEnvironment() {
    const response = await TabSdk.crud.executeDsq({
      dataSourceQueryIdOrName: Constants.Get_VW_UserTenantEnvironmentMapping,
      criteria: {
        Reqtokens: {
          TenantId: TabSdk.store.tenantId,
          AppId: TabSdk.store.appId
        }
      }
    });

    // Store the list of application-wise user environments in the component's property
    this.environmentList = response.Result;

    // Set the default environment from the response or from session storage
    this.environment = TabSdk.store.environmentId ?? response?.Result[response?.Result?.length - 1]?.AppEnvironmentId;
  }

  /**
   * The ngOnDestroy() method is called when the component is about to be destroyed.
   * In this method, we complete the destroy$ observable to indicate that the component is no longer needed.
   */
  ngOnDestroy(): void {
    // Complete the destroy$ observable to indicate that the component is no longer needed
    this.destroy$.next();
    this.destroy$.complete();
  }

  //get menu logo
  getMenuLogo() {
    this._tabOrgAppInfoHelperService.getDefaultAppMediaLocalUrl(this.orgInfo?.Org_Menu_Logo)
      .subscribe((url: any) => {
        if (url) {
          this.orgLogo = url;
        } else {
          this.orgLogo = Constants.Default_Logo;
        }
      });
  }

  /**
   * Gets the language list from the API.
   * This method is called only once, during the component's initialization.
   */
  getLanguageList() {
    // TODO: [BE-REWRITE-PENDING] Re-enable after BE rewrite - Language API. Flow kept, do not remove.
    // this._helperFunctionService
    //   .getDSQData(Constants.FK_TABD_SystemEnumDetails_TABD_SystemEnum_Id, { Id: Constants.Language_Enum_Id })
    //   .subscribe((response: any) => {
    //     this.languageList = response.Result;
    //   });
  }

  private updateActiveScreen() {
    let currentRoute = this.route;
    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
    }

    const screenId = currentRoute.snapshot.paramMap.get('screenId');

    if (screenId && screenId !== '') {
      this.activeScreen = screenId;
      this.clearPreviousActiveMenu();
      this.processActiveMenu();
    } else if (!screenId && this.activeScreen) {
      delete this.activeScreen;
      this.clearPreviousActiveMenu();
    }
  }

  /**
   * Checks the screen width and updates the enablescroll flag accordingly.
   * This method is called when the window is resized.
   * @param event The window resize event.
   */
  checkScreenWidth(event: any) {
    // Get the current screen width
    const screenWidth = window.innerWidth;

    // Check if the screen width is less than 1600px
    // If it is, enable scrolling for the menu
    this.enablescroll = screenWidth <= 1600;

    // Update the menu CSS class based on the enablescroll flag
    this.menuCssClass = this.enablescroll ? 'e-custom-scroll' : '';
  }
  leftMenuSlide() {
    this.panelStatus = !this.panelStatus;
    this.panelOpenClose.emit(this.panelStatus);
  }

  /**
   * Toggles the visibility of the global search component.
   */
  showSearch() {
    this.globalSearch.isShowGlobalSearch = true;
    this.globalSearch.isFullScreen = false;

    const body = document.body; // Access the body element directly.

    this.renderer.addClass(body, 'search-activated'); // Add class if it doesn't exist.
  }

  /**
   * Toggles the visibility of the notification list.
   */
  showNotification() {
    this.isNotificationListVisible = !this.isNotificationListVisible;
  }

  /**
   * Toggles the visibility of the user drop down list.
   */
  userDropDown() {
    this.isUserDropDownVisible = !this.isUserDropDownVisible;
  }
  /**
   * Rebuilds the application by calling the rebuildApp method from _appHelper service.
   * If the rebuild is successful (status code 200), it clears the IndexedDB and stores the schema into IndexedDB.
   */
  async rebuildApp() {
    this.showLoader = true;
    try {
      await TabSdk.util.loadApp({
        rebuild: true,
        partialRebuild: true
      });

      TabSdk.ui.showSuccess({ message: TranslationToken.RebuildSuccess });

    } catch (error) {
      TabSdk.ui.showError({ message: TranslationToken.RebuildFailed });

    } finally {
      this.showLoader = false;
    }
  }

  /**
   * Toggles the visibility of the debug tools component.
   */
  toggleDebugTools() {
    this.devToolBridge.toggleDevTools();
  }

  onChangeEnvironment(event: any) {
    this.environment = event.target.value;
    const authData = this._broadcastChannelService.getAuthData();
    const env = this.environmentList.find((env: any) => env?.AppEnvironmentId === this.environment);

    const transferData = {
      authData,
      appCode: TabSdk.store.appName ?? '',
      environment: {
        Id: env?.AppEnvironmentId,
        Name: env?.EnvironmentName
      }
    };

    let redirectURL = TabSdk.ui.getActiveRedirectUrl();
    let navUrl = '/initializing' + (redirectURL ? `?redirectURL=${redirectURL}` : '');
    TabSdk.ui.navigateToUrl({
      url: this._helperFunctionService.buildAuthTransferUrl(navUrl, transferData),
      replaceUrl: true
    });
  }

  /**
   * Navigates to the documents page in a new isolated tab.
   * Determines the URL based on domain validity.
   */
  goToDocuments() {
    // Construct URL for valid domains
    let newTabUrl = window.location.origin;
    if (TabSdk.store.appId && TabSdk.store.appId?.toLowerCase() !== environment.commonConfig.applicationId?.toLowerCase()) {
      newTabUrl += `/${TabSdk.store.appName}`;
    }
    newTabUrl += '/documents';
    this.openIsolatedTab(newTabUrl);
  }

  // Helper method to open an isolated tab
  openIsolatedTab(url: string) {
    // Option 1: Using "_blank" with "noopener" for security and isolation
    const newTab = window.open(url, '_blank', 'noopener');
    if (newTab) {
      newTab.focus();
    }
  }

  // //Rebuild button and developer mode button hide/show
  // isBuildAndDevelopeModeUsercanAccess() {
  //   // const userData = JSON.parse(this._localStorageService.getLocalStorage(StorageConstants.userInfo))?.user;
  //   // if (
  //   //   userData &&
  //   //   userData.Roles !== null &&
  //   //   userData.Roles.length > 0 &&
  //   //   userData.Roles[0]?.RoleName === Constants.System_Administrator_Role
  //   // ) {
  //   //     return true;
  //   // }

  //   // return false;
  //   //Permission has been added for the system administrator to display the rebuild button for the new tenant.
  //   // return (
  //   //   this.permissionService.doesUserIsTabAdministrator() || this.permissionService.doesUserIsTenantAdministrator()
  //   // );
  // }

  /**
   * Loads the horizontal menu items from the DSQ data source.
   *
   * This method calls the `getDSQData` method of the `helperFunctionService` with the `Default_TABMD_Menu_Items_Id` constant as the parameter.
   * It then updates the `menuItems` property with the received data by calling the `generateMenuItemsFromData` method.
   */
  loadHorizontalMenuitems() {
    const appInfo = TabSdk.store.getAppInfo() ?? {};

    const isAppBuilder = this.permissionService.doesUserIs(UserRole.AppBuilderRoleName);
    const isAppAdmin = this.permissionService.doesUserIs(UserRole.AppAdministratorRoleName);
    const isTenantAdmin = this.permissionService.doesUserIsTenantAdministrator();
    const isTabAdmin = this.permissionService.doesUserIsTabAdministrator();

    const CategoryIds: any = [];

    if (this.isAdminRoute) {
      // 1. Tenant Admin
      //    - Tab Admin or (AppCode === TAB && Role === Tenant Admin)
      if (isTabAdmin || isTenantAdmin) {
        CategoryIds.push(MenuCategoryId.TenantAdmin);
      }

      // 2. Tab Administrator
      if (isTabAdmin) {
        CategoryIds.push(MenuCategoryId.TabAdministrator);
      }
    } else {
      // 1. Administration
      //    - Tab Admin or (AppCode && AppCode !== TAB && (Role === App Admin || Role === Tenant Admin))
      if (isTabAdmin || isTenantAdmin || isAppBuilder || isAppAdmin) {
        CategoryIds.push(MenuCategoryId.Administration);
      }

      // 2. App Builder
      //    - Tab Admin or (AppCode.TenantId === user.TenantId && (Role === App Admin))
      if (
        isTabAdmin ||
        (appInfo?.TenantId?.Id === TabSdk.store.tenantId && isAppBuilder)
      ) {
        CategoryIds.push(MenuCategoryId.AppBuilder);
      }

      // 3. Application
      //    - Default
      CategoryIds.push(MenuCategoryId.Application);
    }

    // User is logged into the TAB platform app itself — no separate second call needed
    const isTabApp = TabSdk.store.appId?.toLowerCase() === environment.commonConfig.applicationId?.toLowerCase();

    // Tab app DSQ: only when CategoryIds exist AND user is not already in the TAB app
    const tabMenuItems = (!isTabApp)
      ? this._helperFunctionService.getDSQData(
          Constants.Header_TABMD_Menu_Items_Id
        )
      : of(null);

    // TAB platform DSQ: only when CategoryIds exist (roles qualify for a menu)
    // Skip if already in TAB app — the tab call above already covers it
    const loggedInAppMenuItems = CategoryIds.length
      ? this._helperFunctionService.getDSQData(
          Constants.Header_TABMD_Menu_Items_Id,
          { CategoryId: CategoryIds.join(',') },
          undefined,
          true,
          { TenantId: TabSdk.store.tenantId }
        )
      : of(null);

    forkJoin([tabMenuItems, loggedInAppMenuItems]).subscribe(([tabResponse, loggedInResponse]: any[]) => {
      const mergedItems = [...(tabResponse?.Result ?? []), ...(loggedInResponse?.Result ?? [])];

      this.menuItems = this.generateMenuItemsFromData(mergedItems);
      setTimeout(() => {
        this.updateActiveScreen();
      }, 500);
    });
  }
  /**
   * Generates the menu items from the given data.
   *
   * This method maps the given data to an array of `MenuItemModel` objects.
   * It then sorts the menu items by their sequence and returns the sorted array.
   * @param data - The data used to generate the menu items.
   * @returns The generated menu items.
   */
  generateMenuItemsFromData(data: any[]): MenuItemModel[] {
    const menuMap = {} as Record<string, MenuItemModel>;
    const result: MenuItemModel[] = [];

    //Handle translations
    data?.forEach(menuItemData => {
      const menuItem = {
        id: menuItemData.Id,
        screenId: menuItemData.ScreenID ?? null,
        text: TabSdk.translator.translate(menuItemData.DisplayName), // Use translated text
        iconCss: `${menuItemData.Icon} e-icons`,
        items: [],
        isSelected: false,
        Sequence: menuItemData.Sequence
      };
      menuMap[menuItemData.Id] = menuItem;
    });

    data?.forEach(menuItemData => {
      const menuItem = menuMap[menuItemData.Id];
      if (menuItemData.ParentID && menuMap[menuItemData.ParentID]) {
        menuMap[menuItemData.ParentID]?.items?.push(menuItem);
        menuMap[menuItemData.ParentID]?.items?.sort((a, b) => {
          const aItem = data?.find(d => d.Id?.toString() === a.id);
          const bItem = data?.find(d => d.Id?.toString() === b.id);
          return (aItem?.Sequence || 0) - (bItem?.Sequence || 0);
        });
      } else {
        result.push(menuItem);
      }
    });

    result?.sort((a, b) => {
      const aItem = data?.find(d => d.Id?.toString() === a.id);
      const bItem = data?.find(d => d.Id?.toString() === b.id);

      const isAApplicationMenu = aItem?.CategoryId?.toLowerCase() === MenuCategoryId.Application?.toLowerCase();
      const isBApplicationMenu = bItem?.CategoryId?.toLowerCase() === MenuCategoryId.Application?.toLowerCase();

      // If one is application menu and other is not, put application menu last
      if (isAApplicationMenu && !isBApplicationMenu) {
        return 1; // a goes after b
      }
      if (isBApplicationMenu && !isAApplicationMenu) {
        return -1; // b goes after a
      }

      // For all other cases (admin routes, same category, no Application category), sort by sequence as before
      return (aItem?.Sequence || 0) - (bItem?.Sequence || 0);
    });

    return result;
  }

  /**
   * Handles the click event on a menu item.
   *
   * If the menu item has a link, navigates to that link.
   * @param args - The event arguments containing the clicked menu item.
   */
  public onMenuItemClicked(args: any) {
    if (args?.item?.screenId && args?.item?.screenId != '') {
      TabSdk.store.removeSession(StorageConstants.screenContext);
      if (this.isAdminRoute) {
        this.router.navigate([`/admin/${args.item.screenId}`]);
      } else {
        this.router.navigate([`/${TabSdk.store.appName}/screen/${args.item.screenId}`]);
      }
    }
  }

  /**
   * Toggles the full screen mode of the application.
   *
   * If the application is not in full screen mode, it will request the full screen
   * mode. If the application is already in full screen mode, it will exit the full
   * screen mode.
   */
  onFullScreenClick() {
    const element = document.querySelector('body') as HTMLElement;
    this.fullScreen = !this.fullScreen;
    if (!document.fullscreenElement) {
      element.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
  }

  public onMenuItemBeforeOpen(event: any) {
    event?.items?.forEach((item: any) => {
      if (item.isSelected) {
        this.highlightMenuItem(event.element, item.id);
      }
    });
  }

  private processActiveMenu() {
    if (!this.activeScreen || !this.menuItems.length) return;

    const findAndHighlightMenuItem = (items: any[], menuId?: string): boolean => {
      if (!items?.length) return false;

      for (const item of items) {
        if (
          item?.screenId?.toLowerCase() === this.activeScreen?.toLowerCase() ||
          item?.id?.toLowerCase() === menuId?.toLowerCase()
        ) {
          item.isSelected = true;
          this.highlightMenuItem(this.menuObj.element, item.id);
          return true;
        }
        if (item?.items?.length && findAndHighlightMenuItem(item.items, menuId)) {
          item.isSelected = true;
          this.highlightMenuItem(this.menuObj.element, item.id);
          return true;
        }
      }
      return false;
    };

    const found = findAndHighlightMenuItem(this.menuObj?.items);
    if (!found) {
      const screenDetail = this._tabScreenHelper.getScreen(this.activeScreen);
      if (!screenDetail?.ScreenConfiguration) return;

      const screenConfiguration = JSON.parse(screenDetail?.ScreenConfiguration ?? '{}');

      if (screenConfiguration?.menu?.length) {
        findAndHighlightMenuItem(this.menuObj?.items, screenConfiguration.menu);
      }
    }
  }

  private highlightMenuItem(element: any, itemId: string) {
    const activeItem = element?.querySelector(`li[id="${itemId}"]`);
    if (activeItem) {
      activeItem.classList.add('selected-item');
    }
  }

  private clearPreviousActiveMenu() {
    const clearHighlights = (items: any[]) => {
      if (!items?.length) return;

      for (const item of items) {
        item.isSelected = false;
        this.clearHighlightedMenuItem(this.menuObj.element, item.id);
        if (item?.items?.length) {
          clearHighlights(item.items);
        }
      }
    };

    clearHighlights(this.menuObj?.items);
  }

  private clearHighlightedMenuItem(element: any, itemId: string) {
    const activeItem = element?.querySelector(`li[id="${itemId}"]`);
    if (activeItem) {
      activeItem.classList.remove('selected-item');
    }
  }

  /**
   * Switches the language of the application.
   * @param event - The event containing the selected language.
   * @returns void
   **/
  async onChangeLanguage(event: any) {
    const selectedLanguage = this.languageList.find((language: any) => language.SystemValue === event.target.value);
    TabSdk.translator.changeLanguage({
      language: selectedLanguage.SystemValue,
      languageCode: selectedLanguage.EnumDetailId
    });
    this.loadHorizontalMenuitems();
  }

  /**
   * Navigate to the previous app.
   * @returns void
   **/
  public navigateToApp(): void {
    // Get the app info from the session storage
    const preAppInfo = this.appNavigation;
    // Set the app info to the service
    this._tabOrgAppInfoHelperService.setAppInfo(preAppInfo.appInfo);
    // Set the app info to the service
    TabSdk.store.environmentId = preAppInfo.appEnv;
    // Navigate to the app
    this.router.navigate([`/${preAppInfo.AppName}/`]);
    // Remove the app navigation from the session storage
    TabSdk.store.removeSession(StorageConstants.appNavigationMapping);
    // Reset the app navigation
    this.appNavigation = null;
  }

  /**
   * Signs out the user by calling the signOut method of the AuthService.
   * Upon successful sign out, navigates to the sign-in page.
   */
  public onSignout() {
    // Call the signOut method of the AuthService and subscribe to the returned Observable
    this._authService.signOut(false).subscribe();
  }
}

// Get the data of the clicked menu item
// const ActiveMenuScreenId = menuItemData.screenId?.match(/\/screen\/(.*)/)[1];
// this._sessionStorageService.setSessionStorage('ActiveMenuScreenId', ActiveMenuScreenId);
// this.highlightSelectedMenuItem(args.item.id);

//  onMenuCreated() {
//   setTimeout(() => {
//     const domMenuItemslist = this.menuObj?.element?.querySelectorAll('li');
//     const ActiveMenuScreenId = this._sessionStorageService.getSessionStorage('ActiveMenuScreenId');
//     if (this.menuItems) {
//       this.menuItems?.forEach((menuItem) => {
//         if (menuItem.screenId?.includes(ActiveMenuScreenId) ) {
//           this.setSelectedclass(domMenuItemslist, menuItem)
//         } else {
//           this.processMenuWhileCreated(menuItem?.items, ActiveMenuScreenId, menuItem, domMenuItemslist)
//         }
//       });
//     }
//   }, 200)
// }

// /**
//  * This function is called when the menu is created and the selected item needs to be highlighted.
//  * It iterates over the menu items and checks if the item's id matches the given idFromUrl. If it does, it adds the
//  * If the item's id does not match the given idFromUrl, it recursively calls the function on the item's children.
//  * @param menuItems the list of menu items
//  * @param ActiveMenuScreenId the id of the selected screen
//  * @param menuItem the parent menu item
//  * @param domMenuItemslist the list of menu items in the DOM
//  */
// processMenuWhileCreated(menuItems: any, ActiveMenuScreenId: any, menuItem: any, domMenuItemslist?: any) {
//   if (menuItems?.length > 0) {
//     menuItems?.forEach((item: any) => {
//       if (item.screenId?.includes(ActiveMenuScreenId)) {
//         this.setSelectedclass(domMenuItemslist, menuItem)
//       } else {
//         this.processMenuWhileCreated(item?.items, ActiveMenuScreenId, menuItem, domMenuItemslist)
//       }
//     })
//   }
// }
// /**
//  * Sets the selected class on the menu item with the given id.
//  * This function iterates over the menu items and removes the 'selected-item' class from all items.
//  * If the item's id matches the given id, it adds the 'selected-item' class to the item.
//  * @param menuItems the list of menu items
//  * @param menuItem the menu item with the id to be selected
//  */
// setSelectedclass(menuItems: any, menuItem: { id: any; }) {
//   menuItems?.forEach((item: any) => {
//     item?.classList?.remove('selected-item');
//     if (item?.getAttribute('id') === menuItem?.id) {
//       item?.classList?.add('selected-item');
//     }else{
//     }
//   });
// }

// highlightSelectedMenuItem(selectedItemId: string): void {
//   const currentUrl = this.router.url;
//   const linkPart = currentUrl?.match(/\/screen\/[^\/]+/);
//   if (linkPart) {
//     const domMenuItemslist = this.menuObj.element.querySelectorAll('li');
//     domMenuItemslist?.forEach((menuItem) => {
//       menuItem?.classList?.remove('selected-item');
//       if (menuItem.getAttribute('id') === selectedItemId) {
//         menuItem.classList.add('selected-item');
//       } else {
//         if (this.menuItems) {
//           this.menuItems?.forEach((childMenu) => {
//             this.processMenuAfterClicked(childMenu.items, selectedItemId, childMenu, domMenuItemslist)
//           })
//         }
//       }
//     });
//   }
// }

// /**
//  * This function is called when the menu is created and the selected item needs to be highlighted.
//  * It iterates over the menu items and checks if the item's id matches the given idFromUrl. If it does, it adds the
//  * If the item's id does not match the given idFromUrl, it recursively calls the function on the item's children.
//  * @param menuItems the list of menu items
//  * @param selectedItemId the id of the selected screen
//  * @param childMenu the parent menu item
//  * @param domMenuItemslist the list of menu items in the DOM
//  */
// processMenuAfterClicked(menuItems: any, selectedItemId: any, childMenu: any, domMenuItemslist?: any) {
//   menuItems?.forEach((childItem: any) => {
//     if (childItem?.id === selectedItemId) {
//       domMenuItemslist?.forEach((menuItem: any) => {
//         menuItem?.classList?.remove('selected-item');
//         if (menuItem?.getAttribute('id') === childMenu?.id) {
//           menuItem?.classList?.add('selected-item');
//         }
//       })
//     } else {
//       this.processMenuAfterClicked(childItem?.items, selectedItemId, childMenu, domMenuItemslist)

//     }
//   })
// }